//@flow
import React, { useEffect, useState } from 'react';
import _ from 'underscore';
import { usePrevious } from '../js/Utils/review-utils';
import {
  FaStar,
  FaStarHalf,
} from 'react-icons/fa';

type Props = {
  rating:number,
  max?:number,
};

// Index starts at 1
const getStarFullness = (index:number, percent:number, total:number):string => {
  const percentPerStar = 100 / total;
  const starPercent = percentPerStar * index;

  if (percent >= starPercent) return 'full';
  const half = starPercent - (percentPerStar / 2);
  const prev = starPercent - percentPerStar;
  if (percent > prev) {
    if (percent > half) return 'full';
    else return 'half';
  }
  return 'none';
};

const renderStar = (props:Props, index:number, percent:number) => {
  const {max = 5} = props;
  const starFullness = getStarFullness(index + 1, percent, max);

  // NOTE: there is some weirdness in avrio where if
  // you name class 'star-icon-container' it will cause
  // the icon rendering to break. Not sure why this happens.
  const cls = `star-container ${starFullness}`;
  return (
    <div
      key={index}
      className={cls}
    >
      <div className="st-item-container">
        <FaStar
          className="star star-full"
        />
      </div>
      <div className="st-half-item-container">
        <FaStarHalf
          className="star star-half"
        />
      </div>
    </div>
  );
};

const Stars = (props:Props) => {
  const {max = 5, rating} = props;

  const [percent, setPercent] = useState(rating || 0);
  const prevRating = usePrevious(rating);

  useEffect(() => {
    if (rating !== prevRating) {
      setPercent(rating);
    }
  }, [rating, prevRating]);

  const starProps:any = {
    className: 'stars',
  };

  return (
    <div {...starProps}>
      {_.range(0, max).map(index => (
        renderStar(props, index, percent)
      ))}
    </div>
  );
};

Stars.defaultProps = {
  max: 5,
  onClick: () => undefined,
};

export default Stars;
